import getApi from '../../api'

export const deleteMessageTemplate = (id: number) =>
  getApi().delete<void>(`/message_templates/${id}`)
